/**
 * Ayuda — Administración → Compras
 */

import { ADM_PUR_ENTITIES_ITEM } from './adm-pur-entities.js'
import { ADM_PUR_ENTITY_GROUPS_ITEM } from './adm-pur-entity-groups.js'
import { ADM_PUR_REMITS_ITEM } from './adm-pur-remits.js'
import { ADM_PUR_INVOICES_ITEM } from './adm-pur-invoices.js'
import { ADM_PUR_ACCOUNTS_ITEM } from './adm-pur-accounts.js'

/** @type {import('../help-index.js').HelpScreen} */
export const ADM_PUR_HELP = {
  screenId: 'adm-pur',
  label: 'Compras',
  navPath: 'Administración → Compras',
  keywords: [
    'compra', 'compras', 'proveedor', 'proveedores', 'factura compra', 'remito compra',
    'cuenta corriente proveedor', 'pendiente de pago', 'saldo proveedor',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'En Compras el menú de la izquierda organiza proveedores, remitos, facturas de compra y cuentas corrientes. Tocá cada tema en esta ayuda para ver el paso a paso.',
  sidebarItems: [
    ADM_PUR_ENTITIES_ITEM,
    ADM_PUR_ENTITY_GROUPS_ITEM,
    ADM_PUR_REMITS_ITEM,
    ADM_PUR_INVOICES_ITEM,
    ADM_PUR_ACCOUNTS_ITEM,
  ],
}
